import { StructuredText } from 'react-datocms';
import type { Document } from 'datocms-structured-text-utils';
import type { AppDownloadBannerFragment } from '@/utils/dato/generated';
import { customNodeRules, renderBlock } from '@/components/structuredText';

const AppDownloadBanner = ({ backgroundColor, body }: AppDownloadBannerFragment) => (
  <div
    className="rounded-xl px-6 py-8 my-8 text-center prose prose-headings:mt-0 max-w-none"
    style={{ backgroundColor: backgroundColor?.hex }}
    data-automation="ZA.appDownloadBanner"
  >
    <StructuredText
      data={{ value: body?.value as Document, blocks: body?.blocks }}
      customNodeRules={customNodeRules}
      renderBlock={renderBlock}
    />
  </div>
);

export default AppDownloadBanner;
